import { useEffect } from 'react';
import '@/App.css';
import Lenis from 'lenis';

import { Scene3D } from './components/Scene3D';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { WhatWeDoSection } from './components/WhatWeDoSection';
import { ROISection } from './components/ROISection';
import { RevenueFlowSection } from './components/RevenueFlowSection';
import { FinalCTASection } from './components/FinalCTASection';
import { MobileBottomCTA } from './components/MobileBottomCTA';
import { Footer } from './components/Footer';

function App() {
  useEffect(() => {
    // Initialize smooth scrolling
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      lenis.destroy();
    }

    return () => lenis.destroy();
  }, []);

  return (
    <div className="App min-h-screen" data-testid="app-container">
      {/* Subtle animated background */}
      <Scene3D />
      
      <Header />
      
      <main className="relative z-10">
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <WhatWeDoSection />
        <ROISection />
        <RevenueFlowSection />
        <FinalCTASection />
      </main>

      <Footer />
      <MobileBottomCTA />
    </div>
  );
}

export default App;
